import { dscvrApi } from '@/shared/api';

export const useFramePostMutation = async (
  request: dscvrApi.frame.FramePostRequest,
  customHeaders?: Record<string, string>,
): Promise<dscvrApi.frame.FramePostResponse> => {
  return await dscvrApi.frame.postFrame(request, customHeaders);
};
